export const IS_LOADING_CALENDAR_HOLIDAYS = 'IS_LOADING_CALENDAR_HOLIDAYS';
export const GET_CALENDAR_HOLIDAYS = 'GET_CALENDAR_HOLIDAYS';
export const FAIL_CALENDAR_HOLIDAYS = 'FAIL_CALENDAR_HOLIDAYS';
